var PaymentTypes = (function() {
    return {
        get: function(paymentType) {
            switch (paymentType.toLowerCase()) {
            case 'paypal':
                return 'PayPal';
            case 'visa':
                return 'Visa';
            case 'mastercard':
                return 'MasterCard';
            case 'amex':
                return 'Amex';
            case 'masterpass':
                return 'MasterPass';
            case 'visacheckout':
                return 'VisaCheckout';
            }
            return paymentType;
        }
    }
})();